export const scrollTo = (id) => {
	const el = document.getElementById(id);
	el && el.scrollIntoView({ block: 'center' });
};
